var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "emojiDialog"
  }, [_c('ul', {
    ref: "emojiPickerListRef",
    staticClass: "emojiDialogList"
  }, _vm._l(_vm.currentEmojiList, function (childrenItem, childrenIndex) {
    return _c('li', {
      key: childrenIndex,
      staticClass: "emojiDialogList-item",
      on: {
        "click": function ($event) {
          return _vm.select(childrenItem, childrenIndex);
        }
      }
    }, [_c('img', {
      staticClass: "emoji",
      attrs: {
        "src": _vm.BASIC_EMOJI_URL + _vm.BASIC_EMOJI_URL_MAPPING[childrenItem]
      }
    })]);
  }), 0), _c('div', {
    staticClass: "sendButtonContainer"
  }, [_c('div', {
    staticClass: "sendButton",
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t("发送")) + " ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }